import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic"

import styles from "./ArticleThumbnail.module.scss"

function ArticleThumbnail({ image }) {

  if(image && image.filename) {
    return (
      <div className={styles.articleThumbnail}>
        <div className={styles.container}>
          <StoryblokImageBasic image={image} />
        </div>
      </div>
    )
  }
  return null
}

export default ArticleThumbnail
